/**
 * @param mdPanelRef {angular.material.MdPanelRef}
 * @param AuthService {AuthService}
 * @param $translationService {$translationService}
 * @param notification {NotificationModel}
 * @constructor
 */
function DayTipController(mdPanelRef, AuthService, $translationService, notification) {
    this.mdPanelRef = mdPanelRef;
    this.authService = AuthService;
    this.$translationService = $translationService;


    this.newsToShow = notification.KeyValueData ? JSON.parse(notification.KeyValueData) : null;
    let language = this.$translationService.getCurrentLanguageCode() || 'en';
    this.tip = "news/" + this.newsToShow.id + "-" + language + ".html";
}

DayTipController.prototype = {
    closeDialog() {
        // Store last show
        let dayTip = {
            lastShow: moment().format("YYYY-MM-DD HH:mm:ss"), lastId: this.newsToShow.id
        };
        this.authService.setUserLocalValue('tip-of-the-day', dayTip);
        this.close();
    },
    
    close() {
        this.mdPanelRef.close();
    }
}


DayTipController.$inject = ['mdPanelRef', 'AuthService', '$translationService', 'notification'];


angular.module('internal.home').controller('DayTipController', DayTipController);